/**
 * Overrides default react-select styles fro CartItem.
 */
export default {
  control: (styles) => ({
    ...styles,
    border: 'none',
    boxShadow: 'none',
    fontSize: '14px',
    lineHeight: '24px',
    height: '0px',
    marginTop: '-4px',
    backgroundColor: 'transparent',
  }),
  valueContainer: (styles) => ({
    ...styles,
    paddingLeft: 0,
    paddingTop: 0,
    marginTop: 0,
    height: '2rem',
  }),
  indicatorsContainer: (styles) => ({ ...styles, height: '26px' }),
  indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: '#FF658B',
    height: '26px',
  }),
  singleValue: (styles) => ({
    ...styles,
    fontSize: '14px',
    lineHeight: '26px',
    marginLeft: '0',
    right: 0,
    textDecoration: 'none',
  }),
  input: (styles) => ({ ...styles, padding: '0', margin: '0' }),
  menu: (styles) => ({ ...styles, minWidth: '200px' }),
  option: (
    styles,
    {
      // eslint-disable-next-line no-unused-vars
      data,
      isDisabled,
      isFocused,
      isSelected,
    },
  ) => ({
    ...styles,
    backgroundColor: isSelected ? 'rgba(60, 60, 60, 0.05)' : 'white',
    color: '#3C3C3C',
    paddingLeft: '40px',
    paddingRight: '40px',
    minWidth: '200px',
  }),
}
